export const SPECIES = {
  dog: '001',
  cat: '002',
} as const
